import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { PATH_LABEL_KEYS, PATH_LABELS, PATHS } from "@/config/paths";
import { useMobile } from "@/providers/mobileProvider";
import { useMobileNavbar } from "@/providers/mobileNavbarProvider";
import { CategoryCard } from "@/components/cards/library/CategoryCard";
import { HEALTH_AREA_MAPPING } from "@/seed/HealthAreaMapping";
import { seo } from "@/utilities/seo";
import { GlobalError } from "@/global-error";
import { NotFound } from "@/not-found";
import { Container } from "@/components/ui/container";
import { useTranslation } from "@/hooks/useTranslation";
import { Heading } from "@/components/ui/heading";

export const Route = createFileRoute("/dashboard/library/")({
  component: LibraryPage,
  notFoundComponent: NotFound,
  errorComponent: GlobalError,
  head: () => ({
    meta: [
      {
        title: `${PATH_LABELS[PATHS.LIBRARY]} - ProgressMade.ai`,
      },
      ...seo({
        title: `${PATH_LABELS[PATHS.LIBRARY]} - ProgressMade.ai`,
        description:
          "Browse the collection of health goals and routines that you can easily add to your account with just one click.",
      }),
    ],
  }),
});

function LibraryPage() {
  const { isMobile } = useMobile();
  const { setMobileNavbar } = useMobileNavbar();
  const { t } = useTranslation();

  // Set up navbar configuration
  useEffect(() => {
    if (isMobile) {
      setMobileNavbar({
        title: t(PATH_LABEL_KEYS[PATHS.LIBRARY]),
      });
    }
  }, [isMobile, setMobileNavbar]);

  return (
    <Container>
      <div className="col-span-12 space-y-0.5">
        {!isMobile && (
          <Heading level="h1" size="h4" className="tracking-tight">
            {t(PATH_LABEL_KEYS[PATHS.LIBRARY])}
          </Heading>
        )}
        <p className="text-muted-foreground">{t("library.description")}</p>
      </div>

      {Object.values(HEALTH_AREA_MAPPING).map((category) => (
        <CategoryCard key={category.slug} category={category as any} />
      ))}
    </Container>
  );
}
